// extracted by mini-css-extract-plugin
export default {"wrap":"ui_wrap__7QTaV"};